import React from "react";
import { useTranslation } from "../../../context/Internationalization";
import ListTable from "../../../Components/Table/ListTable";
import ClubDomainRequestsTableRow from "./ClubDomainRequestsTableRow";

const schema = (t) => [
  {
    id: "club",
    label: t("domain_request_club_column"),
    sortable: false,
    minWidth: 200,
  },
  {
    id: "hostname",
    label: t("domain_request_hostname_column"),
    sortable: false,
    minWidth: 220,
  },
  {
    id: "status",
    label: t("domain_request_status_column"),
    sortable: false,
    minWidth: 140,
  },
  {
    id: "createdAt",
    label: t("domain_request_requested_at_column"),
    sortable: false,
    minWidth: 180,
  },
];

const ClubDomainRequestsTable = ({ requests = [], lastElementRef, loading, emptyMessage }) => {
  const { t } = useTranslation();
  const rowElement = (request) => (
    <ClubDomainRequestsTableRow
      key={request._id}
      lastElementRef={lastElementRef}
      request={request}
    />
  );

  return (
    <ListTable
      rows={requests}
      columns={schema(t)}
      rowElement={rowElement}
      tableAriaLabel={t("domain_requests_admin_panel")}
      minWidth={800}
      loading={loading}
      emptyMessage={emptyMessage}
    />
  );
};

export default ClubDomainRequestsTable;
